const app = require('app');
const marionette = require('backbone.marionette'),
    template = require('../template/errorView.hbs'),
    M = require('shared/messages/messages');

module.exports = marionette.View.extend({
    className: 'col-xs-12',
    template: template,
    templateContext: function () {
        return {
            M: M
        };
    },
});
